import { X } from 'lucide-react';

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  children: React.ReactNode;
}

export function BulkActionBar({ count, onClear, children }: BulkActionBarProps) {
  if (count === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[80] animate-slide-up">
      <div className="flex items-center gap-3 px-4 py-2.5 bg-surface-800 border border-surface-600 rounded-xl shadow-2xl shadow-black/40 max-w-lg">
        <span className="text-sm font-medium text-surface-200 whitespace-nowrap">
          {count} item{count !== 1 ? 's' : ''} selected
        </span>
        <button
          onClick={onClear}
          className="p-1 rounded-md text-surface-400 hover:text-surface-200 hover:bg-surface-700 transition-colors"
          title="Clear selection"
        >
          <X className="h-3.5 w-3.5" />
        </button>
        <div className="w-px h-5 bg-surface-600" />
        <div className="flex items-center gap-2">
          {children}
        </div>
      </div>
    </div>
  );
}
